import { add as addRequest } from 'serviceWorker/db/httpRequests';
import {
  HttpRequestModelType,
  HttpRequestStatus,
} from 'shared/domain/httpRequest/httpRequestModel';
import { InspectionTemplateOutDto } from 'shared/dtos/out/template';
import { InspectionTemplateHttpCreateRequestModel } from '../httpQueue/inspectionTemplate/types';

export class InspectionTemplateCreator {
  constructor(
    private addRequest: (
      request: InspectionTemplateHttpCreateRequestModel
    ) => Promise<unknown>
  ) {}

  async execute(
    inspectionTemplateOutDto: InspectionTemplateOutDto,
    projectId: string,
    uniqueId: string
  ): Promise<void> {
    await this.addRequest({
      createdAt: Date.now(),
      method: 'POST',
      data: {
        inspectionTemplateOutDto,
        uniqueId,
      },
      url: `/project/${projectId}/inspectionTemplate`,
      entityType: HttpRequestModelType.inspectionTemplate,
      status: HttpRequestStatus.NEW,
    });
  }
}

export const inspectionTemplateCreator = new InspectionTemplateCreator(
  addRequest
);
